import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PostCaption = ({ post }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 200;
  const shouldTruncate = post?.caption?.length > maxLength;

  const displayCaption = shouldTruncate && !isExpanded
    ? post?.caption?.slice(0, maxLength) + '...'
    : post?.caption;

  return (
    <div className="p-4 md:p-6 bg-card">
      <div className="flex items-start gap-3 mb-4">
        <Icon name="Calendar" size={20} className="text-muted-foreground flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="caption text-muted-foreground">
            Posted on {new Date(post.timestamp)?.toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </p>
        </div>
      </div>
      <div className="space-y-4">
        <div>
          <p className="text-foreground leading-relaxed whitespace-pre-wrap text-sm md:text-base">
            {displayCaption}
          </p>
          {shouldTruncate && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-primary caption font-medium mt-2 hover:underline"
            >
              {isExpanded ? 'Show less' : 'Show more'}
            </button>
          )}
        </div>

        {post?.hashtags && post?.hashtags?.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {post?.hashtags?.map((tag, index) => (
              <button
                key={index}
                className="caption text-primary font-mono hover:underline"
                aria-label={`View posts tagged ${tag}`}
              >
                #{tag}
              </button>
            ))}
          </div>
        )}

        {post?.location && (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Icon name="MapPin" size={16} />
            <span className="caption">{post?.location}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PostCaption;